import React from "react";
import { Tabs, Tab } from "react-bootstrap";

export const OpenCalcButtons = ({handleClickOpenCalc, labels, showOpenBtnsOnMob}) => {

  const handleClickCalcTab = (chosen) => {
    let unchosen;
    if(chosen=="adapter")
    {
      unchosen=["maturity", "psycho"]
    }
    else{
      if (chosen=="psycho")
      {
        unchosen=["maturity", "adapter"]
      }
      else{
        unchosen=["psycho", "adapter"]
      }
    }
    handleClickOpenCalc(unchosen, chosen);
  }

  return (
    <div >
      <Tabs onSelect={handleClickCalcTab}>
      <Tab  
      eventKey="adapter" title= {labels.adapterScore}>
      </Tab>
      <Tab eventKey="psycho" title={labels.neededPsycho}>
      </Tab>
      <Tab eventKey="maturity" title={labels.neededMaturity}>
      </Tab>
    </Tabs>
    </div>
  )
}